/** Маскирование будет успешно применено, если `phone` содержит номер в любом формате,
 *  в том числе, если код страны равен 8 или отсутствует */
export var maskPhone = function maskPhone(phone) {
  var phoneNumbers = phone.replace(/[^\d*]/g, '');
  phoneNumbers && /[78]/.test(phoneNumbers[0]) && (phoneNumbers = phoneNumbers.slice(1));

  if (!phoneNumbers || phoneNumbers.length !== 10) {
    return phone;
  }

  return "+7 (".concat(phoneNumbers.slice(0, 3), ") ***-**-").concat(phoneNumbers.slice(8, 10));
};
export var phoneToLogin = function phoneToLogin(phone) {
  return phone.replace(/\D/g, '');
};